import { render, staticRenderFns } from "./SurveyResult.vue?vue&type=template&id=f6d338c6"
import script from "./SurveyResult.vue?vue&type=script&lang=js"
export * from "./SurveyResult.vue?vue&type=script&lang=js"
import style0 from "./SurveyResult.vue?vue&type=style&index=0&id=f6d338c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports